import React from 'react';
import classNames from 'classnames';
import "./styles.scss";

export interface ITableCell {
    singleLine?: boolean,
    headerCell?: boolean,
    stickyCol?: boolean,
    small?: boolean,
    style?: object,
    className?: string,
    onClick?: () => void,
    isDesc?: boolean
}

const TableCell: React.FC<ITableCell> = ({isDesc, stickyCol, onClick, children, singleLine = false, headerCell = false, small = false, style = {}, className}) => {
    const cellContainerProps = {
        style,
        className: classNames(`table__cell cell${className ? ` ${className}` : ''}`, {
            "cell--header": !!headerCell,
            "cell--single-line": !!singleLine,
            "cell--small": small,
            "cell--sticky-col": !!stickyCol,
            "cell--sticky-col-row": !!headerCell && !!stickyCol,
            "cell--desc": isDesc
        })
    };

    const cellContent = (): React.ReactNode => {
        return typeof children === 'string' ? (
            <p className={classNames("cell__text", {
                "cell__text--header": !!headerCell,
                "cell__text--small": small
            })}>{children}</p>
        ) : children
    };

    const onClickAction = (e: any) => {
        e.preventDefault();

        if (onClick) {
            onClick();
        }
    };

    if (onClick) {
        return (
            <a href="/#" {...cellContainerProps} onClick={onClickAction}>
                {cellContent()}
            </a>
        )
    }

    return (
        <div {...cellContainerProps}>
            {cellContent()}
        </div>
    );
};

export default TableCell;
